<div class="confirm-dialog">
  <h2 mat-dialog-title>
    <ng-icon *ngIf="data.icon" [name]="data.icon"></ng-icon>
    {{ data.title }}
  </h2>
  
  <mat-dialog-content>
    <p [innerHTML]="data.message"></p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    <button mat-raised-button [color]="data.confirmButtonColor" (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>